export enum Theme {
  BASE = "base",
  AUCTIONS = "auctions",
  PARKING = "parking"
}
